import React, { useState } from "react";
import {
  Button,
  ButtonGroup,
  Col,
  Container,
  Dropdown,
  DropdownToggle,
  Label,
  Row,
} from "reactstrap";
import ArrowRight from "../../../../../assets/icon/arrow-right-purple.svg";
import doubleArrow from "../../../../../assets/icon/double-arrow-down.svg";
import columnSelectorIcon from "../../../../../assets/icon/column-selector.svg";
import greenCircle from "../../../../../assets/icon/status-green-circle.svg";
import threeDotsIcon from "../../../../../assets/icon/three-dots-purple.svg";

import leftArrow from "assets/icon/left-arrow.svg";

import SearchButtons from "components/SearchButtons";
import ReactStrapTable from "components/reactStrapTable";
import Checkbox from "components/common/Fields/Checkbox";
import { useNavigate } from "react-router-dom";

const OrdersDetails = () => {
  const [showPatientsDetails, setPatientsDetails] = useState(false);
  const [rSelected, setRSelected] = useState("off");
  const [tableData, setTableData] = useState(rowData);
  const [data, setData] = useState([]);

  const navigate = useNavigate();

  const togglePatientsDetails = () => {
    setPatientsDetails(!showPatientsDetails);
  };
  const handleBack = () => {
    navigate(-1);
  };

  const herderData = [
    {
      dataField: "all",
      text: (
        <div className="d-flex justify-content-start align-items-center gap-2">
          <Checkbox />
          All
        </div>
      ),
      show: true,
      width: 50,
    },
    {
      dataField: "status",
      text: "Status",
      show: true,
      sort: true,
    },
    {
      dataField: "expectations",
      text: "Expectations",
      show: true,
      sort: true,
      width: 150,
    },
    {
      dataField: "drugname",
      text: "Drug Name",
      show: true,
      sort: true,
      width: 200,
    },
    {
      dataField: "ndcupc",
      text: "NDC/UPC",
      show: true,
      sort: true,
    },
    {
      dataField: "manufacturer",
      text: "Manufacturer",
      show: true,
      sort: true,
      width: 130,
    },
    {
      dataField: "orderqty",
      text: "Order QTY",
      show: true,
      sort: true,
      width: 110,
    },
    {
      dataField: "shippedqty",
      text: "Shipped QTY",
      show: true,
      sort: true,
      width: 110,
    },
  ];

  const rowData = [
    {
      all: <Checkbox />,
      status: <img src={greenCircle} />,
      expectations: "-",
      drugname: "Lisinopril 10mg Tablet",
      ndcupc: "34981319899",
      manufacturer: "Lupin",
      orderqty: "10 BTL",
      shippedqty: "10 BTL",
    },
    {
      all: <Checkbox />,
      status: <img src={greenCircle} />,
      expectations: "Limited DC availability",
      drugname: "Metformin 500mg Tablet",
      ndcupc: "42415977579",
      manufacturer: "Amneal",
      orderqty: "5 BTL",
      shippedqty: "5 BTL",
    },
    {
      all: <Checkbox />,
      status: <img src={greenCircle} />,
      expectations: "-",
      drugname: "Amlodipine 5mg Tablet",
      ndcupc: "38613370164",
      manufacturer: " Alembic",
      orderqty: "8 BTL",
      shippedqty: "8 BTL",
    },
    {
      all: <Checkbox />,
      status: <img src={greenCircle} />,
      expectations: "-",
      drugname: "Omeprazole 20mg Capsule",
      ndcupc: "48548142434",
      manufacturer: "NorthStar",
      orderqty: "3 BTL",
      shippedqty: "3 BTL",
    },
    {
      all: <Checkbox />,
      status: <img src={greenCircle} />,
      expectations: "Substituted Eqv.NDC",
      drugname: "Gabapentin 300mg Capsule",
      ndcupc: "92497230725",
      manufacturer: "Accord",
      orderqty: "5 BTL",
      shippedqty: "5 BTL",
    },
    {
      all: <Checkbox />,
      status: <img src={greenCircle} />,
      expectations: "-",
      drugname: "Simvastatin 20mg Tablet ",
      ndcupc: "95757803602",
      manufacturer: "Teva",
      orderqty: "4 BTL",
      shippedqty: "4 BTL",
    },
    {
      all: <Checkbox />,
      status: <img src={greenCircle} />,
      expectations: "-",
      drugname: "Sertraline 50mg Tablet ",
      ndcupc: "79889412208",
      manufacturer: "Rising",
      orderqty: "3 BTL",
      shippedqty: "3 BTL",
    },
    {
      all: <Checkbox />,
      status: <img src={greenCircle} />,
      expectations: "-",
      drugname: "Pantoprazole 40mg Tablet ",
      ndcupc: "39638933844",
      manufacturer: "Amneal",
      orderqty: "2 BTL",
      shippedqty: "2 BTL",
    },
    {
      all: <Checkbox />,
      status: <img src={greenCircle} />,
      expectations: "-",
      drugname: "Metoprolol Tartrate 25mg Tablet ",
      ndcupc: "55902480611",
      manufacturer: "Alembic",
      orderqty: "2 BTL",
      shippedqty: "1 BTL",
    },
  ];

  const toggleFilter = () => {
    setRSelected((prev) => (prev === "off" ? "on" : "off"));
  };

  return (
    <div className="bg-white  p-3">
      <Container
        fluid
        className="d-flex gap-2 orderEntry-heading section-devider-border mb-1 pb-2"
      >
        <img
          src={leftArrow}
          className="cursor-pointer left-arrow-btn"
          onClick={handleBack}
        />
        <div className="heading-text">Order Details</div>
      </Container>
      <Container fluid>
        <div className="border p-6 bg-white bx-shadow">
          <Row>
            <Col md={12}>
              <h3 className="patient-demo" onClick={togglePatientsDetails}>
                Vendor Details
                <span>
                  {showPatientsDetails ? (
                    <>
                      <img
                        src={doubleArrow}
                        style={{
                          cursor: "pointer",
                          transform: "rotate(180deg)",
                          transition: "opacity 0.3s ease, transform 0.3s ease",
                          marginLeft: "8px",
                        }}
                      />
                      <div
                        style={{
                          borderBottom: "1px solid #D3D3D3",
                          marginTop: "8px",
                        }}
                      ></div>
                    </>
                  ) : (
                    <img
                      src={doubleArrow}
                      style={{
                        cursor: "pointer",
                        transition: "opacity 0.3s ease",
                        marginLeft: "8px",
                      }}
                    />
                  )}
                </span>
              </h3>
              {showPatientsDetails ? (
                <Row>
                  <div className="d-flex justify-content-between">
                    <div>
                      <div class="pdetails">Wholesaler</div>
                      <div className="patient-details">Mc Kesson</div>
                    </div>
                    <div>
                      <div class="pdetails">Order Number</div>
                      <div className="patient-details">MCK-2025012801</div>
                    </div>
                    <div>
                      <div className="pdetails ">Order Date</div>
                      <div className="patient-details">20/01/2025</div>
                    </div>
                    <div>
                      <div className="pdetails">Total Items</div>
                      <div className="patient-details">12</div>
                    </div>
                  </div>
                  <div className="d-flex justify-content-between mt-2">
                    <div>
                      <div className="pdetails ">Ship Date</div>
                      <div className="patient-details">21/01/2025</div>
                    </div>
                    <div>
                      <div className="pdetails ">PO Memo</div>
                      <div className="patient-details">Weekly Stock Order</div>
                    </div>
                    <div>
                      <div className="pdetails ">Order Confirmation</div>
                      <div className="patient-details">CNF-7724691</div>
                    </div>
                    <div>
                      <div className="pdetails ">Total Packages</div>
                      <div className="patient-details">43</div>
                    </div>
                  </div>
                  <div className="d-flex justify-content-between  mt-2">
                    <div>
                      <div className="pdetails ">Total Cost</div>
                      <div className="patient-details">$ 2,752.95</div>
                    </div>
                    <div>
                      <div className="pdetails ">Exceptions</div>
                      <div className="patient-details">3</div>
                    </div>
                    <div>
                      <div className="pdetails"></div>
                      <div className="patient-details"></div>
                    </div>
                    <div>
                      <div className="pdetails "></div>
                      <div className="patient-details"></div>
                    </div>
                  </div>
                </Row>
              ) : (
                <Col sm={12} className="d-flex justify-content-between">
                  <div>
                    <span class="pdetails">Wholesaler: </span>
                    <span className="patient-details">Mc Kesson</span>
                  </div>

                  <div>
                    <span className="pdetails purple-border-left ">
                      Order Number:{" "}
                    </span>
                    <span className="patient-details">MCK-2025012801</span>
                  </div>

                  <div>
                    <span className="pdetails purple-border-left ">
                      Order Date:{" "}
                    </span>{" "}
                    <span className="patient-details">01/20/2025</span>
                  </div>
                  <div>
                    <span className="pdetails purple-border-left ">
                      Ship Date:{" "}
                    </span>
                    <span className="patient-details">21/01/2025</span>
                  </div>
                  <div>
                    <span className="pdetails purple-border-left">
                      Total Item:{" "}
                    </span>
                    <span className="patient-details">12</span>
                  </div>
                </Col>
              )}
            </Col>
          </Row>
        </div>
      </Container>
      <Container fluid>
        <div className="table-card scroll-table position-relative border-0 pt-0 rounded bg-white">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "25px",
            }}
          >
            <div style={{ display: "flex", gap: "6px", alignItems: "center" }}>
              <div>
                {" "}
                <Label>Product Details</Label>
              </div>
              <div>
                <SearchButtons
                  InSize={220}
                  placeHolder={"Search by Product Name"}
                  data={data}
                  setFilterData={setTableData}
                />
              </div>
              <div></div>
              <div>
                <Dropdown isOpen={undefined} toggle={undefined}>
                  <DropdownToggle className="clmn">
                    <img src={columnSelectorIcon} alt="not available" />
                    <span>
                      Columns{" "}
                      {/* {totalCount > 0 && (
                                    <div className="totalcount">{totalCount}</div>
                                  )} */}
                    </span>
                  </DropdownToggle>
                </Dropdown>
              </div>
              <div className="d-flex justify-content-end align-items-center gap-2">
                <span className="f-16 font-weight-600">Filter</span>
                <ButtonGroup className="filter-btn-group">
                  <Button
                    color="info"
                    outline
                    onClick={toggleFilter}
                    active={rSelected === "off"}
                  >
                    OFF
                  </Button>
                  <Button
                    color="info"
                    outline
                    active={rSelected === "on"}
                    onClick={toggleFilter}
                  >
                    ON
                  </Button>
                </ButtonGroup>
              </div>
            </div>
            <img src={threeDotsIcon} alt="icon" />
            {/* <div
              style={{ width: "30px", height: "30px", backgroundColor: "red" }}
            ></div> */}
          </div>
          <div fixed-height={rowData?.length > 0 ? "fixed-height" : "default"}>
            <ReactStrapTable
              id="order-quee-details"
              data={rowData}
              columns={herderData}
              height={200}
            />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default OrdersDetails;
